import React from 'react';
import moment from 'moment';
import { Tooltip } from '@material-ui/core';

export const EMPTY_VALUE = '—';

const tooltipTriggerStyle = { cursor: 'help', borderBottom: '1px dotted currentColor' };
const tooltipBodyStyle = { fontSize: '0.82rem', lineHeight: 1.6, whiteSpace: 'pre-wrap' };

export const isBlank = (value) => value == null || (typeof value === 'string' && value.trim() === '');

export const orDash = (value) => (isBlank(value) ? EMPTY_VALUE : value);

export function formatTableDate(value) {
    if (isBlank(value)) return EMPTY_VALUE;
    const parsed = moment(value, moment.ISO_8601, true);
    return parsed.isValid() ? parsed.format('DD MMM YYYY') : EMPTY_VALUE;
}

/** Turns `[label, value]` pairs into "Label: value" lines, skipping blank values. */
export function buildDetailsText(pairs) {
    return pairs
        .filter(([, value]) => !isBlank(value))
        .map(([label, value]) => `${label}: ${value}`)
        .join('\n');
}

export const DetailsTooltip = ({ title, children }) => (
    <Tooltip title={<span style={tooltipBodyStyle}>{title}</span>} placement="top" arrow>
        <span style={tooltipTriggerStyle}>{children}</span>
    </Tooltip>
);

export const renderWithDetails = (value, details) => {
    const display = orDash(value);
    return details ? <DetailsTooltip title={details}>{display}</DetailsTooltip> : display;
};

export const renderTableDate = (value) => (
    <span style={{ whiteSpace: 'nowrap' }}>{formatTableDate(value)}</span>
);
